import Service from "../../AuthService";
const RROrder = {
    getRROrder(page) {
        return Service.get("/rr-order?page="+page);
    },
    showRROrder(id) {
        return Service.get("/rr-order/"+id);
    },
    createRROrder(data) {
        return Service.post("/rr-order" ,data);
    },
    updateRROrder(id,data) {
        return Service.put("/rr-order/"+id ,data);
    },
    deleteRROrder(id){
        return Service.delete("/rr-order/"+id );
    },
    searchByVendor(vendor){
        return Service.get("/rr-vendor-search?vendor_id="+vendor)
    },
    search(page,data){
        return Service.get(`/rr-order-search?page=${page}&rr=${data.rr}&date_start=${data.date_start}&date_end=${data.date_end}&vendor=${data.vendor}&status=${data.status}&excel=${data.excel}&amount=${data.amount}`);
    },
    generateRR(date){
        return Service.get('generate_rr_number?date='+date)
    }
};
export default RROrder;
